import store from "../../../store";
import vacation_filter from "./vacation/vacation_filter.vue";
import trip_filter from "./trip/trip_filter.vue";

if(jQuery('#calendar_vacation').length > 0)  {
    window.calendar_vacation = new Vue({
        store,
        el: '#calendar_vacation',
        name: "calendar_vacation",
        created() {

        },
        components: {
            vacation_filter
        }
    })
}


if(jQuery('#calendar_trip').length > 0)  {
    window.calendar_trip = new Vue({
        store,
        el: '#calendar_trip',
        name: "calendar_trip",
        created() {

        },
        components: {
            trip_filter
        }
    })
}
